import ImageCustom from '@/components/Image'
import { ThumbType } from '@/libs/types'
import React from 'react'

const Thumb: React.FC<{ thumb: ThumbType, alt: string }> = ({ thumb, alt }) => {

    const thumbnail = thumb?.data?.attributes?.url || thumb?.data?.attributes?.formats?.small?.url || thumb

    if (!thumbnail) return <></>
    return (
        <div className="post__thumb rounded my-4 w-100 aspect_ratio_16_9">
            <ImageCustom src={thumbnail} fill alt={alt} className="object-fit-cover" />
        </div>
    )
}

export default Thumb